const idTokenKey = 'ID-TOKEN'
const usernameKey = 'CURRENT-USER'
const userRoleKey = 'ROLE'
const userDepotKey = 'DEPORT'
const userSpidKey = 'SPID'
const userCurrentUrl = 'CURRENT-URL'

const getIdToken = () => {
  return window.localStorage.getItem(idTokenKey)
}

const setIdToken = (token: string) => {
  return window.localStorage.setItem(idTokenKey, token)
}

const getUsername = () => {
  return window.localStorage.getItem(usernameKey)
}

const setUsername = (username:string) => {
  return window.localStorage.setItem(usernameKey, username)
}

const getUserRole = () => {
  return window.localStorage.getItem(userRoleKey)
}

const setUserRole = (username:string) => {
  return window.localStorage.setItem(userRoleKey, username)
}

const getUserDepot = (): string[] => {
  let userDepots = window.localStorage.getItem(userDepotKey);
  if (userDepots == undefined) {
    return [];
  }
  return userDepots.split(",");
}

const setUserDepot = (depot:string) => {
  return window.localStorage.setItem(userDepotKey, depot)
}

const getUserSpid = () => {
  return window.localStorage.getItem(userSpidKey)
}

const setUserSpid = (spid:string) => {
  return window.localStorage.setItem(userSpidKey, spid)
}

const getUserUrl = () => {
  return window.localStorage.getItem(userCurrentUrl)
}

const setUserUrl = (url: string) => {
  return window.localStorage.setItem(userCurrentUrl, url)
}

const hasToken = (): Boolean => {
  return getIdToken() !== null
}

const clear = () => {
  window.localStorage.clear()
}

export {
  getIdToken,
  setIdToken,
  getUsername,
  setUsername,
  hasToken,
  getUserRole,
  setUserRole,
  getUserDepot,
  setUserDepot,
  getUserSpid,
  setUserSpid,
  getUserUrl,
  setUserUrl,
  clear
}
